/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import { FaImage } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { update } from '../../services/item';
import { uploadPic, uploadPicFromUrl } from '../../services/pic';
import { deepCloneArray } from '../../utils/array';
import { InputSimple } from '../form/input.Simple';
import { ModalGlobal } from '../modal/modal.Global';
import { IconPicker } from '../icons/icon.Picker';
import { getId } from '../../utils/item';

export const PicNew = props => {
  const { itemId } = props;

  const item = useSelector(state => state.items[itemId]);

  const [selectedIconSlug, setSelectedIconSlug] = useState(null);
  const [lastCreatedPicId, setLastCreatedPicId] = useState(null);

  const persistPicPatch = useCallback(
    (targetPicId, patch) => {
      if (!Array.isArray(item?.pics)) {
        return;
      }
      const clonedPics = deepCloneArray(item.pics);
      const picIndex = clonedPics.findIndex(picObj => getId(picObj) === targetPicId);
      if (picIndex === -1) {
        return;
      }
      clonedPics[picIndex][targetPicId] = {
        ...clonedPics[picIndex][targetPicId],
        ...patch,
      };
      update(`items/${itemId}`, 'pics', clonedPics);
    },
    [item?.pics, itemId]
  );

  const createPicEntry = useCallback(
    (payload = {}) => {
      const normalizedUrl = payload?.url || null;
      const normalizedIcon =
        payload?.iconSlug !== undefined ? payload.iconSlug : selectedIconSlug;
      if (!normalizedUrl && !normalizedIcon) {
        return null;
      }
      const sourcePics = Array.isArray(item?.pics) ? item.pics : [];
      const clonedPics = deepCloneArray(sourcePics);
      const id = uuid().replace('-', '');
      const newPicObj = {
        [id]: {
          url: normalizedUrl,
          iconSlug: normalizedIcon || null,
          bgColor: null,
          x: 0,
          y: 0,
          w: 1,
          h: 4,
          i: id,
        },
      };
      update(`items/${itemId}`, 'pics', [...clonedPics, newPicObj]);
      return id;
    },
    [item?.pics, itemId, selectedIconSlug]
  );

  const handleNewPic = (type, e) => {
    if (type === 'local') {
      uploadPic(e).then(res => {
        if (res?.data?.url) {
          const createdId = createPicEntry({ url: res.data.url });
          if (createdId) {
            setLastCreatedPicId(createdId);
          }
        }
      });
    }
    if (type === 'url') {
      uploadPicFromUrl(e).then(res => {
        if (res?.data?.url) {
          const createdId = createPicEntry({ url: res.data.url });
          if (createdId) {
            setLastCreatedPicId(createdId);
          }
        }
      });
    }
  };

  const handleIconChange = useCallback(
    slug => {
      const normalizedSlug = slug || null;
      setSelectedIconSlug(normalizedSlug);
      if (lastCreatedPicId) {
        persistPicPatch(lastCreatedPicId, { iconSlug: normalizedSlug });
        return;
      }
      if (normalizedSlug) {
        const createdId = createPicEntry({ iconSlug: normalizedSlug });
        if (createdId) {
          setLastCreatedPicId(createdId);
        }
      }
    },
    [createPicEntry, lastCreatedPicId, persistPicPatch]
  );

  return (
    <ModalGlobal
      title='edition'
      idToOpen={'addPic'}
      onClose={() => {
        setSelectedIconSlug(null);
        setLastCreatedPicId(null);
      }}
    >
      <div className='flex items-center gap-1'>
        <div className='flex-1'>
          <div className='w-full px-1 mt-1'>
            <label className='relative block py-03 cursor-pointer w-full bg-primary rounded shadow flex items-center justify-center gap-1'>
              <FaImage /> Depuis l'ordinateur
              <input
                className='invisible absolute'
                type='file'
                name='file'
                onChange={e => handleNewPic('local', e)}
                accept='image/*'
              />
            </label>
          </div>

          <div className='flex w-full'>
            <InputSimple
              className=''
              placeholder={'depuis une url'}
              onBlur={value => handleNewPic('url', value)}
            />
          </div>
        </div>
      </div>

      <div className='mt-2'>
        <IconPicker
          size={28}
          value={selectedIconSlug}
          onChange={(label, slug) => handleIconChange(slug)}
          placeholder="Choisir une icône (optionnel)"
          label='Icône'
          previewSize={32}
          inputClassName='mt-1'
          gridClassName='mx-1'
          maxHeight={150}
          onClear={() => handleIconChange(null)}
        />
      </div>
    </ModalGlobal>
  );
};
